export class ApplicationError extends Error {
    public constructor(message: string) {
        super(message);
        this.name = this.constructor.name;
    }
}

export class NotImplementedError extends ApplicationError {
    public constructor() {
        super("Operation not implemented");
    }
}

export class NotSupportedError extends ApplicationError {
    public constructor(message?: string) {
        super(message ?? "Operation not supported");
    }
}

export class InvalidProgramStateError extends ApplicationError {
    public constructor(message?: string) {
        super("Invalid program state" + (message != undefined ? ": " + message : ""));
    }
}

export class InvalidArgumentError extends ApplicationError {
    public constructor(argumentName: string, message?: string) {
        super(
            message != undefined ? `${message} (argument: ${argumentName})` : `Invalid argument value: ${argumentName}`
        );
    }
}

export class TypingError extends ApplicationError {
    public constructor() {
        super("Invalid typing");
    }
}

export function isAbortException(e: unknown): e is DOMException {
    return e instanceof DOMException && e.name === "AbortError";
}
